<script setup lang="ts">
// TODO: В будущем вынести компонент в ui-layer
const PLUG_PADDING = 2

type Props = { effectShadow?: boolean; parentClass?: string }

const props = defineProps<Props>()

const refShadowContainer = ref<HTMLDivElement | null>(null)
const refShadowElement = ref<HTMLDivElement | null>(null)

const componentClass = computed(() => {
  const classes = ['container-shadow']

  const classModification = props.effectShadow
    ? `container-shadow--active`
    : `container-shadow--disabled`

  classes.push(classModification)

  return classes
})

// Обработчик появления затенения
const onHandleShadow = (event: Event) => {
  if (!refShadowElement.value) return

  // Тип Event не соответсвует сигнатуре property у target
  const { scrollTop, scrollHeight, clientHeight } = event.target as Element

  if (scrollTop + clientHeight + PLUG_PADDING >= scrollHeight) {
    refShadowElement.value.style.display = 'none'
  } else {
    if (refShadowElement.value.style.display === 'block') return

    refShadowElement.value.style.display = 'block'
  }
}

// Рекурсия поиска колекции элементов для затенения
const findParentListElements = (
  element: HTMLElement,
): HTMLCollection | null => {
  if (!props.parentClass) return null

  // Проверяем, содержит ли текущий элемент нужный класс
  if (element.classList.contains(props.parentClass)) return element.children

  // Иначе проходим по всем дочерним элементам
  for (const child of element.children) {
    const found = findParentListElements(child as HTMLElement)

    if (found) return found
  }

  return null
}

const onInitShadow = () => {
  if (!refShadowContainer.value || !refShadowElement.value) return

  const { children, clientHeight } = refShadowContainer.value

  const parentList = props.parentClass
    ? findParentListElements(refShadowContainer.value)
    : children

  if (!parentList) return

  // Рассчитываем высоту дочерних элементов
  let totalHeight = Array.from(parentList).reduce((acc, child) => {
    return acc + child.clientHeight
  }, 0)

  // Рассчет стандартных отступов
  totalHeight += (parentList.length - 1) * 16

  // В случае если высота элементов в сумме меньше контейнера, или высота не определена
  if (totalHeight < clientHeight || !clientHeight) {
    refShadowElement.value.style.display = 'none'
  }
}

onMounted(async () => {
  if (!props.effectShadow || !refShadowContainer.value) return

  refShadowContainer.value.addEventListener('scroll', onHandleShadow)

  await nextTick(() => onInitShadow())
})

onBeforeUnmount(() => {
  if (!props.effectShadow || !refShadowContainer.value) return

  refShadowContainer.value.removeEventListener('scroll', onHandleShadow)
})
</script>

<template>
  <div ref="refShadowContainer" v-bind="$attrs" :class="componentClass">
    <slot />
  </div>

  <div ref="refShadowElement" class="container-shadow__element" />
</template>

<style scoped lang="scss">
$width-scroll: 5px;

.container-shadow {
  position: relative;
  height: 100%;

  &--active {
    overflow-y: scroll !important;
  }

  &--disabled {
    overflow-y: unset !important;
  }

  .container-shadow > * {
    height: auto;
  }

  &__element {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    pointer-events: none;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    );

    @include media('>tablet') {
      width: calc(100% - $width-scroll);
    }
  }
}
</style>
